var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 59.5,
    r: 41.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.61 44.2812L87.296 48.7731L93.9658 32.1484L78.201 39.1821L82.4606 42.0147L80.7715 43.7961C77.3146 40.6687 72.8252 38.7762 67.9241 38.7762C57.0302 38.7762 48.1672 48.1226 48.1672 59.6107C48.1672 62.3465 48.6769 65.0394 49.6562 67.5426L42.0908 75.5205L50.1506 78.3537L52.8371 86.8531L60.4025 78.8751C62.7763 79.9079 65.3299 80.4453 67.9241 80.4453C78.8181 80.4453 87.681 71.0989 87.681 59.6107C87.681 54.4423 85.8864 49.7079 82.9207 46.0626L84.61 44.2812ZM88.2451 38.1812L86.7637 41.8737L85.9824 40.5673L84.7435 39.7434L88.2451 38.1812ZM47.7177 74.1198L50.8722 70.7931L54.0961 71.9264L50.9415 75.2531L47.7177 74.1198ZM54.1654 80.9192L53.0908 77.5196L56.2455 74.1929L57.32 77.5927L54.1654 80.9192ZM57.2858 59.6107C57.2858 53.4248 62.0581 48.3921 67.9241 48.3921C73.7901 48.3921 78.5624 53.4248 78.5624 59.6107C78.5624 65.7967 73.7901 70.8293 67.9241 70.8293C65.5381 70.8293 63.333 69.9966 61.5564 68.5922L63.7368 66.293C64.9383 67.1331 66.3776 67.6239 67.9241 67.6239C72.1141 67.6239 75.5229 64.0291 75.5229 59.6106C75.5229 55.1921 72.1141 51.5973 67.9241 51.5973C63.7341 51.5973 60.3253 55.1921 60.3253 59.6106C60.3253 61.2415 60.7908 62.7593 61.5875 64.0264L59.4072 66.3256C58.0755 64.4522 57.2858 62.1269 57.2858 59.6107ZM63.3648 59.6107C63.3648 56.9596 65.4101 54.8028 67.9241 54.8028C70.4381 54.8028 72.4834 56.9596 72.4834 59.6107C72.4834 62.2618 70.4381 64.4187 67.9241 64.4187C67.2211 64.4187 66.5549 64.2498 65.9597 63.9488L68.9984 60.7443L66.8491 58.4779L63.8104 61.6823C63.525 61.0546 63.3648 60.352 63.3648 59.6107ZM67.9241 77.24C65.0281 77.24 62.1924 76.4487 59.6879 74.9474L58.6484 71.6589L59.3916 70.8752C61.7324 72.851 64.6995 74.0346 67.9241 74.0346C75.4661 74.0346 81.602 67.5641 81.602 59.6107C81.602 51.6574 75.4661 45.1868 67.9241 45.1868C60.3822 45.1868 54.2463 51.6574 54.2463 59.6107C54.2463 63.0112 55.3687 66.1402 57.2423 68.6087L56.4992 69.3924L53.3807 68.2962C51.9571 65.655 51.2067 62.6648 51.2067 59.6107C51.2067 49.89 58.7062 41.9815 67.9241 41.9815C77.1421 41.9815 84.6415 49.89 84.6415 59.6107C84.6415 69.3315 77.1421 77.24 67.9241 77.24Z",
    fill: "#FC7BB6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 137,
    height: 137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.3e3b2ce1d37c99d2a38cfb0bcc871df9.svg";
export { ForwardRef as ReactComponent };